import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgShareAlt = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M23.625 12.25v10.5a1.75 1.75 0 0 1-1.75 1.75H6.125a1.75 1.75 0 0 1-1.75-1.75v-10.5a1.75 1.75 0 0 1 1.75-1.75H8.75a.875.875 0 0 1 0 1.75H6.125v10.5h15.75v-10.5H19.25a.875.875 0 1 1 0-1.75h2.625a1.75 1.75 0 0 1 1.75 1.75Zm-13.38-4.631 2.88-2.882v10.138a.875.875 0 0 0 1.75 0V4.737l2.88 2.882a.876.876 0 0 0 1.24-1.238l-4.376-4.375a.876.876 0 0 0-1.238 0L9.006 6.38a.875.875 0 1 0 1.238 1.238Z" />
  </svg>
);
export default SvgShareAlt;
